import { render, staticRenderFns } from "./PrformanceUser.vue?vue&type=template&id=527dbac4&scoped=true"
import script from "./PrformanceUser.vue?vue&type=script&lang=js"
export * from "./PrformanceUser.vue?vue&type=script&lang=js"
import style0 from "./PrformanceUser.vue?vue&type=style&index=0&id=527dbac4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527dbac4",
  null
  
)

export default component.exports